<template>
    <div id="search">
        <div class="head-tool">
            <i class="el-icon-search"></i>
            <input type="text" v-model="search">
            <span @click="searchBtn">搜索</span>
        </div>

        <!--<ul class="menu">-->
            <!--<li class="fl" :class="{active:order==2}" @click="editOrder(2)"><a>人气</a></li>-->
            <!--<li class="fl" :class="{active:order==6}" @click="editOrder(6)"><a>收藏</a></li>-->
            <!--<li class="fl" :class="{active:order==1}" @click="editOrder(1)"><a>点击</a></li>-->
            <!--<li class="fl" :class="{active:order==3}" @click="editOrder(3)"><a>字数</a></li>-->
        <!--</ul>-->
        <ul class="booklist" v-infinite-scroll="doSearch">
            <router-link :to="{name:'Book',params:{wid:item.wid}}" tag="li" v-for="item in bookList">
                <span class="finish"><img :src="require('./../assets/images/finish' + item.is_finish +'.png')" alt=""></span>
                <el-image :src="'http://static.yuread.cn/' + item.h_cover + '@!thumb'" fit="fit" lazy></el-image>
                <div>
                    <p class="title">{{item.title}}</p>
                    <p class="description">{{item.sort_description}}</p>
                    <p class="author">{{item.author}}</p>
                </div>

            </router-link>

        </ul>
    </div>
</template>

<script>
    export default {
        name: "Search",
        data(){
            return {
                search : this.$route.query.search,
                page : 0,
                limit : 20,
                order : 2,
                bookList : [],
                total : 0,
                pages : 1,
            }
        },
        methods : {
            doSearch(){
                this.page ++;
                if(this.page > this.pages){
                    return;
                }
                this.axios.post('/api/search/doSearch',{
                    search : this.search,
                    page : this.page,
                    limit : this.limit,
                    order : this.order
                }).then(r => {
                    let data = r.data;
                    this.pages = data.data.pages;
                    this.total = data.data.total;
                    if(this.total == 0){
                        this.$message.error("抱歉！没有搜到相关书籍,为您推荐以下热门书籍")
                    }
                    data.data.data.forEach(v => {
                        this.bookList.push(v);
                    })

                })
            },
            editOrder(order){
                this.order = order;
                this.page = 0;
                this.bookList = [];
                this.doSearch();

            },
            searchBtn(){
                this.page = 0;
                this.bookList = [];
                this.doSearch();
            }
        }
    }
</script>

<style lang="less">
    #search{background: #f6f6f7;height: 100%;
        .head-tool{padding:20px;position:relative;background: #fff;
            input{
                width: 600px;background: #F6F7F9;border: none;
                height: 60px;border-radius: 60px;text-indent: 60px;font-size: 30px;}
            i{position: absolute;top: 35px;left: 35px;}
            span{margin-left: 20px;}
        }
        .menu{height:80px;border-bottom:1px solid #efefef;
            margin-top: 20px;background: #fff;display: flex;

            li{flex:1;text-align: center;
                a{line-height: 80px;height:80px;display:inline-block;color:#333;}

            }
            li.active{
                a{
                    border-bottom: 3px solid @theme;color:@theme;font-size: 30px;
                }

            }
        }
        .booklist{padding: 20px;background: #fff;height:calc(100% - 200px);overflow:auto;
            li{overflow: auto;border-bottom: 1px solid #efefef;padding: 10px 0;position:relative;
                .el-image{width:120px;height: 160px;float: left;box-shadow: 0 1px 3px rgba(0,0,0,.3);padding: 0;
                    img{width: 100%;height: 100%;}
                }
                div{float: left;width:580px; padding-left: 20px;
                    p{padding: 5px 0;}
                    .title{font-size: 28px;color: #272727;}
                    .description{color:#666;font-size: 24px;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;}
                    .author{color:#b0b0b0;font-size: 24px;}
                }

                .finish{width:60px;height:60px;position: absolute;top:6px;left:-1px;z-index: 99;
                    img{width:100%;height:100%;box-shadow: none;}
                }
            }
        }
    }
</style>
